import React from 'react';

import { U } from '../../../../assets/img/svg/details';

import young from "../../../../assets/img/young-woman.webp";

const Data: React.FC<{title: string; text: string;}> = ({ title, text }) => {
    return <div className='group p-6 relative max-w-48 justify-self-center'>
            <div className='absolute left-0 top-0 w-full h-full after:content-[""] after:h-28 after:w-2 after:bg-main-blue after:rounded-lg after:absolute after:left-0 after:bottom-0 after:-z-10 before:h-2 before:w-28 before:bg-light-yellow before:rounded-lg before:absolute before:left-0 before:bottom-0 before:-z-10 transition-all duration-200 group-hover:-scale-y-100'>
                <span className='border-l-[8px] border-b-[8px] border-main-pink w-10 h-10 inline-block absolute left-0 bottom-0'></span>
            </div>

            <div className='transition-all duration-200'>
                <h3 className="text-2xl font-semibold mb-1">{title}</h3>
                <p className="text-sm">{text}</p>
            </div>
        </div>;
};

const AboutSection: React.FC = () => {
    return (
        <section className='pb-10 pt-8'>
            <div className="max-w-screen-xl mx-auto px-4 grid md:grid-cols-2 gap-8 items-center">
                <div className="flex justify-center items-end relative">
                    <div className="flex items-end justify-center relative">
                        <img src={young} alt="Jovem estudande" className='absolute overflow-hidden rounded-[45%] -bottom-1 left-1/2 -translate-x-1/2 max-h-[100%] h-auto w-full object-contain' />
                        <U className='w-full h-[300px] md:h-[500px] object-contain' />
                    </div>
                </div>

                <div className="grid grid-cols-2 gap-y-10 items-end">
                    <Data title="+ de 500" text="Faculdades e universidades parceiras" />
                    <Data title="+ de 25 anos" text="Anos atuando na escolha profissional da vida dos jovens." />
                    <Data title="+ de 1M de estudantes" text="Mais de um milhão de jovens atendidos em todo o brasil." />
                    <Data title="Milhares" text="de histórias inspiradas e transformadas" />
                </div>
            </div>
        </section>
    );
};

export default AboutSection;